import { selectRouteParams } from 'selectors/general';
import { connect } from 'react-redux';
import { parseDateInTimezone } from 'helpers/intl-fns';
import { stateToHTML } from 'draft-js-export-html';
import { waivers } from 'store/saga/entities/bound';
import { makePath } from 'helpers/link-generation';
import { selectReservation, selectWaiverVersion, selectEnabledWaiverVersionId } from './YieldManagement.selectors';
import ViewWaiver from './ViewWaiver';

const mapStateToProps = state => {
  const { venueId, startDate, scheduleId, reservationId, waiverId, waiverVersionId } = selectRouteParams(state);
  const reservation = selectReservation(state, reservationId);
  const currentWaiverVersionId = selectEnabledWaiverVersionId(state, venueId);
  const { isLoaded, isLoading, data } = selectWaiverVersion(
    state,
    waivers.defaultKey(null, 'version', venueId, waiverId, waiverVersionId)
  );
  const backToClassesHref = startDate && makePath.classes({ venueId, startDate, scheduleId, tab: 'roster' });

  let signedOn;
  let firstName;
  let lastName;

  if (reservation) {
    ({ firstName, lastName } = reservation);
    signedOn = parseDateInTimezone(reservation.waiverSignedTimestamp, 'UTC');
  }

  return {
    isLoading: isLoading || !reservation,
    backToClassesHref,
    firstName,
    lastName,
    signedOn,
    outOfDate: currentWaiverVersionId !== waiverVersionId,
    waiverHTML: isLoaded ? stateToHTML(data.waiver) : '',
  };
};

export default connect(mapStateToProps)(ViewWaiver);
